import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export async function createDeliverable(payload: any) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.ACADEMIC_DELIVERABLES.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateDeliverable(id: number, payload: any) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.ACADEMIC_DELIVERABLES.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}